import Vue from 'vue';

const cart = {
    state: {
        cart: [],
        cartItem: null
    },
    mutations: {
        setCart(state, cart) {
            state.cart = cart;
        },
        setCartItem(state, cartItem) {
            state.cartItem = cartItem;
        },
        addItem(state, data) {
            for (let i = 0; i < state.cart.length; i++) {
                if (state.cart[i].store.token === data.store.token) {
                    for (let j = 0; j < state.cart[i].items.length; j++) {
                        if (state.cart[i].items[j].token === data.token) {
                            state.cart[i].items[j].quantity = data.quantity;

                            return;
                        }
                    }

                    state.cart[i].items.push(data);
                    return;
                }
            }

            state.cart.push({
                'items': [data],
                'store': data.store
            });
        },
        removeItem(state, {cartItemToken, storeToken}) {
            const storeIndex = state.cart.findIndex(c => c.store.token === storeToken);
            const store = state.cart[storeIndex];

            const updatedStore = {...store, ...{items: store.items.filter(item => item.token !== cartItemToken)}};

            if (!updatedStore.items.length) {
                state.cart.splice(storeIndex, 1);
                return;
            }

            Vue.set(state.cart, storeIndex, updatedStore);
        }
    },
    actions: {
        async fetchCart({commit}) {
            const {data} = await axios.get("/api/cart");
            commit("setCart", data);
        },
        async addIntoCart({commit}, form) {
            try {
                const {data} = await axios.post(`/api/cart`, form);
                commit("setCartItem", data.data);
                commit("addItem", data.data);
            } catch (errors) {
                //
            }
        },
    },
    getters: {
        totalItems(state) {
            return state.cart.reduce((sum, store) => {
                return sum + store.items.length
            }, 0);
        }
    }
};

export default cart;
